export default __webpack_public_path__ + "604bdf88d745293ed39d43128bf4fa69.woff";